
export const toggleLowItem=(value)=>{
    return (dispatch,getState)=>{
        dispatch({
            type:'TOGGLE_LOW_ITEM',
            value
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/salesLoader/lowItemsActions.js